import { Box, SxProps, Theme } from '@mui/material';

/** Size used for flag icons from flagcdn.com (Flagpedia CDN). */
const FLAG_SIZE = 'h40';

export type CountryFlagProps = {
  /** ISO 3166-1 alpha-2 country code (e.g. "us", "ar"). */
  readonly countryCode: string;
  /** MUI sx props for layout and spacing. */
  readonly sx?: SxProps<Theme>;
};

/**
 * Renders a country flag image using flagcdn.com (Flagpedia CDN).
 * Default size is 24x18px.
 */
export function CountryFlag({ countryCode, sx }: CountryFlagProps) {
  const code = countryCode.toLowerCase();
  const src = `https://flagcdn.com/${FLAG_SIZE}/${code}.png`;
  return (
    <Box
      component="img"
      src={src}
      alt=""
      sx={{ width: 24, height: 18, flexShrink: 0, ...sx }}
      loading="lazy"
    />
  );
}
